import * as React from "react";
import {
  BalanceUpdateScheduledTournamentPurchaseDetailsFragmentFragment,
} from "../../../hooks/useTransactions/graphql/TransactionsFragment.generated";
import { Trans } from "react-i18next";

export const BalanceUpdateScheduledTournamentPurchaseDetails = ({
  details,
}: {
  details: BalanceUpdateScheduledTournamentPurchaseDetailsFragmentFragment;
}) => {
  return (
    <Trans i18nKey="transaction.BalanceUpdateTournamentPurchaseDetails_details">
      Purchased tournament entry <strong>{{ name: details.tournamentName }}</strong>
    </Trans>
  );
};
